export const getUserAdHostPayOutResults = async (url, token) => {
  try {
    const response = await fetch(
      `${url}/ad-host-pay-out-result/user-pay-out-results`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        // body: JSON.stringify(inputData),
      }
    );

    const resData = await response.json();

    console.log(resData, response);

    if (!response.ok) {
      throw new Error("something wrong");
    } 

    return resData;
      
  } catch (err) {
    console.log(err);
    throw err;
  }
};